import React from 'react';
import SEO from '../components/SEO';
import ServicesHero from '../components/ServicesHero';
import ClientTestimonials from '../components/ClientTestimonials';
import WhatWeDo from '../components/WhatWeDo';
import WhatWeDont from '../components/WhatWeDont';
import HowFractionalWorks from '../components/HowFractionalWorks';
import ServicesPackages from '../components/ServicesPackages';
import Onboarding from '../components/Onboarding';
import ServicesFAQ from '../components/ServicesFAQ';
import ServicesFinalCTA from '../components/ServicesFinalCTA';

const ServicesPage = () => {
  return (
    <div className="services-page">
      <SEO 
        title="Our Services - FractionalVA" 
        description="Explore our virtual assistant services, designed for leaders who need to delegate tasks and focus on growth. See what we do, what we don't do, and how we can help you." 
        name="FractionalVA"
        type="website"
      />
      <ServicesHero />
      <ClientTestimonials />
      <WhatWeDo />
      <WhatWeDont />
      <HowFractionalWorks />
      <ServicesPackages />
      <Onboarding />
      <ServicesFAQ />
      <ServicesFinalCTA />
    </div>
  );
};

export default ServicesPage;